export const getNumberOrZero = (number?: number): number => {
  return number || 0
}
